export const GUEST_AVATAR = 'guest'
export const EMPTY_AVATAR = 'empty'
